<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/said-events', text: 'said_events_title' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'said_events_title' | translate}}</h1>
        <aside *ngIf="canPickStudent && !isDenied">
            <button type="button" class="btn btn-outline" (click)="toggleStudentPicker(true)">
                <i class="fi fi-rs-user"></i>
                {{'said_events_btnPickStudent' | translate}}
            </button>
        </aside>
    </header>

    <div class="content-desc" *ngIf="filterValue">
        {{filterValue.Planning_period_name}}
    </div>

    <app-person-picker *ngIf="studentPickerOpened" (pick)="pickStudent($event)"></app-person-picker>

    <ng-container *ngIf="!studentPickerOpened">
        <app-alert level="warning" *ngIf="isUnavailable">
            <div [innerHTML]="unavailableText | safeHtml"></div>
        </app-alert>

        <div *ngIf="!isUnavailable">
            <app-alert level="danger" *ngIf="isDenied || (isLoaded && (!personDataList || !personDataList.length))">
                {{'eServiceNotAvailable' | translate}}
            </app-alert>

            <ng-container *ngIf="!isDenied">
                <ng-container *ngIf="!isUnavailable">
                    <app-alert level="warning" *ngIf="isLoaded && noSelectionNeeded && !isSetKPInfoTextIsOn">
                        {{'said_events_noSelectionNeeded' | translate}}
                    </app-alert>

                    <ng-container *ngIf="isLoaded">
                        <div class="data-value" *ngIf="studentFullName && (isAdmin || isImpersonator)">
                            <label>{{'said_events_student' | translate}}</label>
                            <div>{{studentFullName}} ({{studentUpn}})</div>
                        </div>

                        <div *ngIf="personDataList && personDataList.length > 1" class="mb-3">
                            <app-select [placeholder]="'said_events_lblDropType' | translate"
                                        [(ngModel)]="filterValue"
                                        name="filterValue"
                                        [options]="personDataList"
                                        [displayProperty]="'Study_program'"
                                        (selectionChange)="loadEvents($event.value.Student_guid, $event.value.Planning_period_GUID)">
                            </app-select>
                        </div>

                        <app-alert level="info">
                            <div><strong>{{'said_events_skills_under_supervision' | translate}}</strong></div>
                            <div *ngIf="pointsInfoHtml" [innerHTML]="pointsInfoHtml | safeHtml"></div>
                            <div>
                                <a href="#" (click)="$event.preventDefault(); navigateToFilterSupervised()">
                                    {{'said_events_supervised_filter_title' | translate}}
                                </a>
                            </div>
                        </app-alert>

                        <app-alert level="info" *ngIf="formInfoHtml">
                            <div [innerHTML]="formInfoHtml | safeHtml"></div>
                        </app-alert>
                    </ng-container>
                </ng-container>
            </ng-container>
        </div>
    </ng-container>

    <div class="block" *ngIf="rights.view && !studentPickerOpened && isLoaded && !isUnavailable">
        <header class="block-header">
            <h3 [translate]="'said_events_AddedEvents_title' | translate"></h3>
            <aside>
                <button type="button" (click)="addEvent()" class="btn btn-outline-primary"
                        *ngIf="!studentPickerOpened && isLoaded" [disabled]="!getPersonMainDataHadResult">
                    <i class="fi fi-rs-plus"></i>
                    {{'said_events_addCource' | translate}}
                </button>
            </aside>
        </header>

        <app-alert level="warning" *ngIf="!selectedStudentEvents.length">
            {{'said_events_noProgramAdded' | translate}}
        </app-alert>

        <app-said-event-card *ngFor="let c of selectedStudentEvents; let i = index;" [data]="c" [studentId]="selectedStudent_guid"></app-said-event-card>
    </div>

    <app-alert level="info" *ngIf="rights.view && !studentPickerOpened && isLoaded && formExplanationsHtml && !isUnavailable">
        <div><strong>{{'said_events_explanations' | translate}}</strong></div>
        <div [innerHTML]="formExplanationsHtml | safeHtml"></div>
    </app-alert>
</div>
